import { render, staticRenderFns } from "./GoogleTrending.vue?vue&type=template&id=49674ee2&scoped=true"
import script from "./GoogleTrending.vue?vue&type=script&lang=js"
export * from "./GoogleTrending.vue?vue&type=script&lang=js"
import style0 from "./GoogleTrending.vue?vue&type=style&index=0&id=49674ee2&prod&lang=css"
import style1 from "./GoogleTrending.vue?vue&type=style&index=1&id=49674ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49674ee2",
  null
  
)

export default component.exports